import Tool from '../Tool'
import $ from 'jquery'

/**
 * Select tool class
 *
 * @param {Object} config
 * @constructor
 */
export default class Deselect extends Tool {
  constructor(config) {
    super()

    $.extend(this, config)

    this.enableToggle = false
  }

  /**
   * Deselect all features on activation
   */
  activate() {
    this.select.getFeatures().clear()
  }
}
